import React from "react";

import "./src/styles/global.css"

import HeaderWrapper from './src/components/headerwrapper';

export const wrapPageElement = ({ element, props }) => (
  <HeaderWrapper {...props}>{element}</HeaderWrapper>
);
